import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ProfileService } from 'src/app/_services/profile.service';
import Swal from 'sweetalert2';
import { ProfiloUtenteComponent } from '../../../profilo-utente/profilo-utente.component';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { HobbyService } from 'src/app/_services/hobby.service';
import { UtilityService } from 'src/app/_services/utility.service';
import { environment } from 'src/environments/environment';

const envStorage = `${environment.file}`;

@Component({
  selector: 'app-hobbies',
  templateUrl: './hobbies.component.html',
  styleUrls: ['./hobbies.component.css']
})
export class HobbiesComponent {
  @Input('profile_hobby') profile_hobby: any;
  parentId: any;
  all_hobby: any;
  count_hobby: any;
  child_hobby: any;
  newCompIcon: string = 'https://img.icons8.com/ios/96/8E8F9A/add--v1.png';
  newCompForm = new FormGroup({
    hobby_id: new FormControl<number | null>(null, Validators.required)
  });
  data: string;
  editControl: boolean = false;
  teamInitial = '';
  childHobbyLoaded: { [key: string]: boolean } = {};
  elementIndex: any;
  selectedHobby: any;

  /* Form Richiesta Hobby */
  requestForm: FormGroup;

  @ViewChild('mySelect') mySelect_macro: any;
  @ViewChild('mySelect_category') mySelect_category: any;

  constructor(
    private hobbyService: HobbyService,
    private sanitizer: DomSanitizer,
    private profileService: ProfileService,
    private profilecomponent: ProfiloUtenteComponent,
    private fb: FormBuilder,
    public utilityService: UtilityService
  ) {
    this.requestForm = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      genericrequestcategory_id: [1],
      hobby_id: []
    });
  }

  onMouseOver(id: number) {
    this.elementIndex = this.all_hobby.findIndex(
      (item: { id: number }) => item.id === id
    );

    if (this.elementIndex !== -1) {
      const hoveredItem = this.all_hobby[this.elementIndex];
      if (
        !hoveredItem &&
        !hoveredItem.children &&
        hoveredItem.children.length < 0
      ) {
        this.elementIndex = null;
      }
    }

    this.selectedHobby = this.all_hobby[this.elementIndex].id;
  }

  ngOnInit() {
    // this.personalHobbies();
    this.parentHobbies();
  }

  initForm() {
    this.requestForm = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      genericrequestcategory_id: [1],
      hobby_id: []
    });
  }

  ngOnChanges(profile_hobby: SimpleChanges): void {}

  enableEditMode() {
    if (this.editControl == false) {
      this.editControl = true;
    } else this.editControl = false;
  }

  public getSantizeUrl(url: string) {
    if (url === null) {
      url = `${envStorage}/users/profile/default.jpeg`;
    } else {
      let image = this.sanitizer.bypassSecurityTrustUrl(url);
    }
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  openSelect_hobby() {
    this.mySelect_macro.open();
  }
  openSelect_hobby_category() {
    this.mySelect_category.open();
  }

  parentHobbies() {
    let utility = this.utilityService;

    this.hobbyService.parentHobbies().subscribe(res => {
      this.all_hobby = res.result;
      this.count_hobby = res.count_hobby;

      this.all_hobby.forEach(function (hobby: any) {
        hobby.filestorage.path = utility.getSanitizeUrl(hobby.filestorage.path);

        hobby.children.forEach(function (children: any) {
          children.filestorage.path = utility.getSanitizeUrl(
            children.filestorage.path
          );
        });
      });
    });
  }

  // ottieni le sottocategorie in base all'id della categoria di hobby
  childHobbies(hobby_id: any) {
    let utility = this.utilityService;
    this.child_hobby = null;
    this.hobbyService.childHobbies(hobby_id).subscribe(res => {
      this.child_hobby = res.result;
      this.child_hobby.forEach(function (children: any) {
        children.filestorage.path = utility.getSanitizeUrl(
          children.filestorage.path
        );
      });
    });
  }

  //aggiunta di un hobby
  addHobby(hobby_id: string) {
    this.hobbyService.addHobby(hobby_id).subscribe({
      next: res => {
        {
          this.profilecomponent.personalHobbies();
          this.parentHobbies();

          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'success',
            iconColor: '#FFB26B',
            title: 'Hobby inserito',
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
        }
      },
      error: err => {
        // Handle error response
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'error',
          iconColor: '#FFB26B',
          title: err.error.message,
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      }
    });
  }

  // eliminazione hobby e tutte le sottocategorie o solo sottocategoria hobby passando l'id di essa
  deleteHobbyUser(hobby: any) {
    Swal.fire({
      text: 'Confermi di voler eliminare ' + hobby.alias + '?',
      showCancelButton: true,
      cancelButtonText: 'Annulla',
      cancelButtonColor: '#00337C',
      showConfirmButton: true,
      confirmButtonText: 'Conferma',
      confirmButtonColor: '#FFB26B',
      reverseButtons: true,
      customClass: {
        popup: 'main-font'
      },
      backdrop: '#f4f3efad',
      position: 'center',
      target: '.mat-card-content'
    }).then(result => {
      if (result.isConfirmed) {
        this.hobbyService.deleteHobbyUser(hobby.id).subscribe(res => {
          this.parentHobbies();
          this.profilecomponent.personalHobbies();
        });

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: hobby.alias + ' eliminato',
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      }
    });
  }

  cleanForm() {
    this.requestForm.reset();
  }

  /* RICHIESTA NUOVO HOBBY */
  clearRequestForm() {
    this.requestForm.reset({ genericrequestcategory_id: 1 });
  }

  addRequest(hobby?: string) {
    hobby
      ? this.requestForm.patchValue({ hobby_id: hobby })
      : this.requestForm.patchValue({ hobby_id: this.selectedHobby });

    this.hobbyService.reqNewHobby(this.requestForm.value).subscribe({
      next: (res: any) => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Richiesta inoltrata con successo',
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      },
      error: (err: any) => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'error',
          iconColor: '#FFB26B',
          title: 'Qualcosa è andato storto',
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      }
    });

    this.clearRequestForm();
  }
}
